const publicUrl = process.env.PUBLIC_URL;

const Svgs = {
  arrowDown: `${publicUrl}/svgs/arrow-down.svg`,
  info: `${publicUrl}/svgs/info.svg`,
  arrowGreen: `${publicUrl}/svgs/arrow-green.svg`,
};

const Images = {
  bedGreen: `${publicUrl}/images/bed-green.png`,
  youthGreen: `${publicUrl}/images/youth-green.png`,
  seniorGreen: `${publicUrl}/images/senior-green.png`,
}

export  {Svgs, Images}